export const isValidTelegramChatId = (value) => /^-?\d{5,64}$/.test(String(value || "").trim());

export const toFormChannel = (channel) => {
  const normalized = String(channel || "email").toLowerCase();
  if (normalized === "sms") return "Sms";
  if (normalized === "telegram") return "Telegram";
  if (normalized === "email") return "Email";
  return "Push";
};

export const parseIntervalMinutes = (value) => {
  const parsed = Number.parseInt(value, 10);
  return Number.isNaN(parsed) ? 10 : Math.min(10080, Math.max(0, parsed));
};

export const hasSameSubscriptionContact = (first, second) => {
  const channel = String(first.channel || second.channel || "").toLowerCase();
  if (channel === "telegram") {
    const firstHasUser = first.userId !== null && first.userId !== undefined;
    const secondHasUser = second.userId !== null && second.userId !== undefined;
    if (firstHasUser !== secondHasUser) return false;
    if (firstHasUser && String(first.userId) !== String(second.userId)) return false;
    return Boolean(
      first.telegramChatId &&
      second.telegramChatId &&
      String(first.telegramChatId) === String(second.telegramChatId)
    );
  }
  if (first.userId && second.userId) return first.userId === second.userId;
  if (channel === "email") {
    return Boolean(first.customEmail && second.customEmail && first.customEmail === second.customEmail);
  }
  if (channel === "sms") {
    return Boolean(first.customPhone && second.customPhone && first.customPhone === second.customPhone);
  }
  return false;
};
